/**
 * Export default Block Gmaps JS
 * @uses {
 * - pluginGoogleMaps
 * }
 * @description Since most of the JS on this file is not needed ASAP, we lazy load this as a route
 */
export default {
	complete: () => {
		const { google: { apiKey } } = am2;

		if (!apiKey) {
			// eslint-disable-next-line no-console
			return console.warn('Please setup an API key for using Google Maps.');
		}

		const { fn: { loadJs } } = am2;

		// Google Script is lazyloaded
		loadJs(`https://maps.googleapis.com/maps/api/js?key=${apiKey}`, () => {
			// ...as well as this small plugin
			import( /* webpackChunkName: "plugins/am2-GoogleMaps" */ "./../../plugins/am2-GoogleMaps").then(() => {
				const { GoogleMap } = am2;
				GoogleMap.init(document.querySelectorAll('[data-plugin-google]'));
			});
		});
	}
}
